import React from "react";
import { Typography } from "antd";

import { W0 } from "@components/Constants";

export type Claim = {
  name: string;
  description: string;
};

type Props = {
  claims: Claim[];
};

const ClaimsList = ({ claims }: Props): JSX.Element => {
  const claimStyle = {
    marginBottom: W0 / 2,
  };

  const renderClaim = ({ name, description }: Claim) => (
    <Typography.Paragraph key={name} style={claimStyle}>
      <Typography.Text code>{name}</Typography.Text>

      {" "}

      <Typography.Text type="secondary">{description}</Typography.Text>
    </Typography.Paragraph>
  );

  return (
    <>
      {claims.map(renderClaim)}
    </>
  );
};

export default ClaimsList;
